module.exports = __webpack_public_path__ + "static/media/protocols3.61f09ca9.png";